module.exports = __webpack_public_path__ + "assets/img/00147.601a3d23.png";